import type { Carousel } from '@/redux/modules/itemCarousel/itemCarousel.types';

/**
 * IDs for the "Similar upcoming sales" grid on price-results — must stay aligned with
 * `PriceResultsCarousels.tsx` so the loader only fetches summaries for rendered lots.
 */
export const getPriceResultsSimilarUpcomingItemIds = (carousels: Carousel[]): number[] => {
    const newSimilarItemsCarousel = carousels.find((c) => c.title.toLowerCase() === 'new similar items');
    const newSimilarItemsIds = newSimilarItemsCarousel?.itemIds ?? [];
    const shouldUseNewSimilarItems = newSimilarItemsIds.length > 0;
    return shouldUseNewSimilarItems ? newSimilarItemsIds : (carousels[1]?.itemIds ?? []);
};
